<p-toast></p-toast>

<div class="flex flex-column gap-4" [formGroup]="form">

    <p-accordion [multiple]="true" [activeIndex]="[0,1,2,3]" expandIcon="pi pi-chevron-down"
        collapseIcon="pi pi-chevron-up">
        <p-accordionTab header="Core Details" [selected]="true">
            <div class="formgrid grid">
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900" for="name">Institute Name <span
                            class="text-red-500">*</span></label>
                    <input pInputText id="name" type="text" class="w-full"
                        placeholder="Enter full name of the institute" formControlName="name" />
                    <div *ngIf="form.get('name')?.touched && form.get('name')?.invalid">
                        <small *ngIf="form.get('name')?.hasError('required')" class="p-error block">Name is
                            required.</small>
                        <small *ngIf="form.get('name')?.hasError('pattern')" class="p-error block">Name must contain
                            only letters and spaces.</small>
                    </div>
                    <small *ngIf="form.get('name')?.hasError('instituteNameExists')" class="p-error block">Institute
                        with this name already exists.</small>
                </div>

                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900" for="instituteCode">Institute Code <span
                            class="text-red-500">*</span></label>
                    <input pInputText id="instituteCode" type="text" class="w-full" placeholder="Unique identifier"
                        formControlName="instituteCode" />
                    <div *ngIf="form.get('instituteCode')?.touched && form.get('instituteCode')?.invalid">
                        <small *ngIf="form.get('instituteCode')?.hasError('required')" class="p-error block">Institute Code is
                            required.</small>
                    </div>
                    <small class="text-500 block mt-1">Alphanumeric, max 50 characters</small>
                </div>

                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900" for="yearOfEstablishment">Year of Establishment</label>
                    <input pInputText id="yearOfEstablishment" type="text" class="w-full" placeholder="YYYY"
                        formControlName="yearOfEstablishment" />
                    <div *ngIf="form.get('yearOfEstablishment')?.touched && form.get('yearOfEstablishment')?.invalid">
                        <small *ngIf="form.get('yearOfEstablishment')?.hasError('required')" class="p-error block">Year
                            of establishment is required.</small>
                        <small *ngIf="form.get('yearOfEstablishment')?.hasError('pattern')" class="p-error block">Must
                            be a number.</small>
                    </div>
                </div>

                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900" for="instituteOrCollageType">Institute/College Type</label>
                    <p-dropdown id="instituteOrCollageType" [options]="instituteTypes" placeholder="Select type"
                        styleClass="w-full" [showClear]="true" formControlName="instituteOrCollageType"></p-dropdown>
                    <div
                        *ngIf="form.get('instituteOrCollageType')?.touched && form.get('instituteOrCollageType')?.invalid">
                        <small *ngIf="form.get('instituteOrCollageType')?.hasError('required')"
                            class="p-error block">Type is required.</small>
                    </div>
                </div>

                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900" for="controlOfInstitution">Control of Institution</label>
                    <p-dropdown id="controlOfInstitution" [options]="controlTypes" placeholder="Select control type"
                        styleClass="w-full" [showClear]="true" formControlName="controlOfInstitution"></p-dropdown>
                    <div *ngIf="form.get('controlOfInstitution')?.touched && form.get('controlOfInstitution')?.invalid">
                        <small *ngIf="form.get('controlOfInstitution')?.hasError('required')"
                            class="p-error block">Control of Institution is required.</small>
                        <small *ngIf="form.get('controlOfInstitution')?.hasError('pattern')" class="p-error block">Must
                            contain only letters and spaces.</small>
                    </div>
                </div>

                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900" for="branchCampuses">Branch Campuses</label>
                    <input pInputText id="branchCampuses" type="text" class="w-full" placeholder="Number of branches"
                        formControlName="branchCampuses" />
                    <div *ngIf="form.get('branchCampuses')?.touched && form.get('branchCampuses')?.invalid">
                        <small *ngIf="form.get('branchCampuses')?.hasError('pattern')" class="p-error block">Must be a
                            number.</small>
                    </div>
                </div>

                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900" for="netPriceCalculator">Net Price Calculator</label>
                    <input pInputText id="netPriceCalculator" type="text" class="w-full"
                        formControlName="netPriceCalculator" />
                    <div *ngIf="form.get('netPriceCalculator')?.touched && form.get('netPriceCalculator')?.invalid">
                        <small *ngIf="form.get('netPriceCalculator')?.hasError('pattern')" class="p-error block">Must be
                            a valid URL.</small>
                    </div>
                </div>

                <div class="field col-12">
                    <label class="font-medium text-900" for="missionStatement">Mission Statement</label>
                    <textarea pInputTextarea id="missionStatement" rows="3" class="w-full"
                        placeholder="Enter mission statement or description"
                        formControlName="missionStatement"></textarea>
                    <div *ngIf="form.get('missionStatement')?.touched && form.get('missionStatement')?.invalid">
                        <small *ngIf="form.get('missionStatement')?.hasError('required')" class="p-error block">Mission
                            statement is required.</small>
                        <small *ngIf="form.get('missionStatement')?.hasError('pattern')" class="p-error block">Invalid
                            characters in mission statement.</small>
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <label class="font-medium text-900 block mb-2">Branch Campus Names</label>
                <div class="flex flex-wrap gap-2 mb-3">
                    <div *ngFor="let campus of branchCampusNames.controls; let i = index" class="campus-chip">
                        <span class="chip-text">{{ campus.value }}</span>
                        <i class="pi pi-times chip-close" (click)="removeCampus(i)"></i>
                    </div>
                </div>
                <div class="flex gap-2">
                    <input pInputText type="text" class="w-full md:w-30rem campus-input" placeholder="Add campus name"
                        [(ngModel)]="newCampusName" [ngModelOptions]="{standalone: true}" (keyup.enter)="addCampus()" />
                    <button pButton label="Add" class="campus-add-btn" type="button" (click)="addCampus()"></button>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Media Assets">
            <div class="grid">
                <div class="col-12 md:col-6">
                    <label class="upload-label">Logo</label>
                    <div class="upload-container" [class.has-file]="logoPreview" (click)="triggerUpload('logo')">
                        <input type="file" #logoInput hidden (change)="onFileSelect($event, 'logo')" accept="image/*" />
                        <ng-container *ngIf="!logoPreview">
                            <i class="pi pi-upload"></i>
                            <span class="upload-text">Drag & drop or click to upload</span>
                            <span class="upload-hint">Square image, max 5MB</span>
                        </ng-container>
                        <div *ngIf="logoPreview" class="preview-container">
                            <img [src]="logoPreview" alt="Logo preview" />
                            <div class="preview-overlay">
                                <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger"
                                    [loading]="loading" (click)="removeFile('logo', $event)"></button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 md:col-6">
                    <label class="upload-label">Institute Image/Banner</label>
                    <div class="upload-container" [class.has-file]="bannerPreview" (click)="triggerUpload('banner')">
                        <input type="file" #bannerInput hidden (change)="onFileSelect($event, 'banner')"
                            accept="image/*" />
                        <ng-container *ngIf="!bannerPreview">
                            <i class="pi pi-upload"></i>
                            <span class="upload-text">Drag & drop or click to upload</span>
                            <span class="upload-hint">Square image, max 10MB</span>
                        </ng-container>
                        <div *ngIf="bannerPreview" class="preview-container">
                            <img [src]="bannerPreview" alt="Banner preview" />
                            <div class="preview-overlay">
                                <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger"
                                    [loading]="loading" (click)="removeFile('banner', $event)"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Contact Information">
            <div class="formgrid grid">
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900" for="webSite">Website</label>
                    <input pInputText id="webSite" type="text" class="w-full" placeholder="https://example.edu"
                        formControlName="webSite" />
                    <div *ngIf="form.get('webSite')?.touched && form.get('webSite')?.invalid">
                        <small *ngIf="form.get('webSite')?.hasError('required')" class="p-error block">Website is
                            required.</small>
                        <small *ngIf="form.get('webSite')?.hasError('pattern')" class="p-error block">Must be a valid
                            URL (e.g., https://example.com).</small>
                    </div>
                </div>

                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900" for="countryId">Country</label>
                    <p-dropdown id="countryId" [options]="countries" optionLabel="name" optionValue="countryCode"
                        placeholder="Select country" styleClass="w-full" [filter]="true" filterBy="name"
                        [showClear]="true" formControlName="countryCode"></p-dropdown>
                    <small *ngIf="form.get('countryCode')?.invalid && form.get('countryCode')?.touched"
                        class="p-error">Country is required.</small>
                </div>

                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900" for="provinceId">Province/State</label>
                    <div class="dropdown-with-add">
                        <p-dropdown id="provinceId" [options]="provinces" optionLabel="name" optionValue="id"
                            placeholder="Select state/province" styleClass="w-full" [filter]="true" filterBy="name"
                            [showClear]="true" formControlName="provinceId"></p-dropdown>
                        <button type="button" class="add-inline-btn" [disabled]="!form.get('countryCode')?.value"
                            (click)="openAddProvinceDialog()" pTooltip="Add new province" tooltipPosition="top">
                            <i class="pi pi-plus"></i>
                        </button>
                    </div>
                    <small *ngIf="form.get('provinceId')?.invalid && form.get('provinceId')?.touched"
                        class="p-error">Province/State is required.</small>
                </div>

                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900" for="cityId">City</label>
                    <div class="dropdown-with-add">
                        <p-dropdown id="cityId" [options]="cities" optionLabel="name" optionValue="id"
                            placeholder="Select city" styleClass="w-full" [filter]="true" [showClear]="true"
                            formControlName="cityId"></p-dropdown>
                        <button type="button" class="add-inline-btn" [disabled]="!form.get('provinceId')?.value"
                            (click)="openAddCityDialog()" pTooltip="Add new city" tooltipPosition="top">
                            <i class="pi pi-plus"></i>
                        </button>
                    </div>
                    <small *ngIf="form.get('cityId')?.invalid && form.get('cityId')?.touched" class="p-error">City is
                        required.</small>
                </div>

                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900">Degree of Urbanization</label>
                    <p-dropdown [options]="urbanizationLevels" placeholder="Select urbanization level"
                        styleClass="w-full" [showClear]="true" formControlName="degreeOfUrbanization"></p-dropdown>
                    <div *ngIf="form.get('degreeOfUrbanization')?.touched && form.get('degreeOfUrbanization')?.invalid">
                        <small *ngIf="form.get('degreeOfUrbanization')?.hasError('pattern')" class="p-error block">Must
                            contain only letters and spaces.</small>
                    </div>
                </div>

                <div class="field col-12">
                    <label class="font-medium text-900" for="address">Address</label>
                    <textarea pInputTextarea id="address" rows="2" class="w-full"
                        placeholder="e.g. 123 Main St, Building #5, City - only letters, numbers, spaces and .,#-&#64;"
                        formControlName="address"></textarea>
                    <div *ngIf="form.get('address')?.touched && form.get('address')?.invalid">
                        <small *ngIf="form.get('address')?.hasError('required')" class="p-error block">Address is
                            required.</small>
                        <small *ngIf="form.get('address')?.hasError('pattern')" class="p-error block">Use only letters,
                            numbers, spaces and ., # - &#64;</small>
                    </div>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Facilities">
            <div class="formgrid grid">
                <div class="field col-12 md:col-4 flex align-items-center gap-3">
                    <p-checkbox formControlName="sportsFacilities" [binary]="true"
                        inputId="sportsFacilities"></p-checkbox>
                    <label for="sportsFacilities" class="font-medium text-900 mb-0 cursor-pointer">Sports
                        Facilities</label>
                </div>
                <div class="field col-12 md:col-4 flex align-items-center gap-3">
                    <p-checkbox formControlName="swimmingPool" [binary]="true" inputId="swimmingPool"></p-checkbox>
                    <label for="swimmingPool" class="font-medium text-900 mb-0 cursor-pointer">Swimming Pool</label>
                </div>
                <div class="field col-12 md:col-4 flex align-items-center gap-3">
                    <p-checkbox formControlName="gym" [binary]="true" inputId="gym"></p-checkbox>
                    <label for="gym" class="font-medium text-900 mb-0 cursor-pointer">Gym</label>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Institute Activities">
            <div class="formgrid grid">
                <div class="field col-12 md:col-4 flex align-items-center gap-3">
                    <p-checkbox formControlName="culturalFestivals" [binary]="true"
                        inputId="culturalFestivals"></p-checkbox>
                    <label for="culturalFestivals" class="font-medium text-900 mb-0 cursor-pointer">Cultural
                        Festivals</label>
                </div>
                <div class="field col-12 md:col-4 flex align-items-center gap-3">
                    <p-checkbox formControlName="techFests" [binary]="true" inputId="techFests"></p-checkbox>
                    <label for="techFests" class="font-medium text-900 mb-0 cursor-pointer">Tech Fests</label>
                </div>
                <div class="field col-12 md:col-4 flex align-items-center gap-3">
                    <p-checkbox formControlName="collegeFests" [binary]="true" inputId="collegeFests"></p-checkbox>
                    <label for="collegeFests" class="font-medium text-900 mb-0 cursor-pointer">College Fests</label>
                </div>
                <div class="field col-12 md:col-4 flex align-items-center gap-3">
                    <p-checkbox formControlName="clubsAndSocieties" [binary]="true"
                        inputId="clubsAndSocieties"></p-checkbox>
                    <label for="clubsAndSocieties" class="font-medium text-900 mb-0 cursor-pointer">Clubs and
                        Societies</label>
                </div>
                <div class="field col-12 md:col-4 flex align-items-center gap-3">
                    <p-checkbox formControlName="tech" [binary]="true" inputId="tech"></p-checkbox>
                    <label for="tech" class="font-medium text-900 mb-0 cursor-pointer">Tech</label>
                </div>
                <div class="field col-12 md:col-4 flex align-items-center gap-3">
                    <p-checkbox formControlName="arts" [binary]="true" inputId="arts"></p-checkbox>
                    <label for="arts" class="font-medium text-900 mb-0 cursor-pointer">Arts</label>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Research Facilities">
            <div class="formgrid grid">
                <div class="field col-12 md:col-6 flex align-items-center gap-3">
                    <p-checkbox formControlName="entrepreneurship" [binary]="true"
                        inputId="entrepreneurship"></p-checkbox>
                    <label for="entrepreneurship"
                        class="font-medium text-900 mb-0 cursor-pointer">Entrepreneurship</label>
                </div>
                <div class="field col-12 md:col-6 flex align-items-center gap-3">
                    <p-checkbox formControlName="labAndResearchCentres" [binary]="true"
                        inputId="labAndResearchCentres"></p-checkbox>
                    <label for="labAndResearchCentres" class="font-medium text-900 mb-0 cursor-pointer">Lab & Research
                        Centres</label>
                </div>
                <div class="field col-12 md:col-6 flex align-items-center gap-3">
                    <p-checkbox formControlName="fundingForStudentProjects" [binary]="true"
                        inputId="fundingForStudentProjects"></p-checkbox>
                    <label for="fundingForStudentProjects" class="font-medium text-900 mb-0 cursor-pointer">Funding for
                        Student Projects</label>
                </div>
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900" for="publicationsPerYear">Publications Per Year</label>
                    <input pInputText id="publicationsPerYear" type="number" class="w-full"
                        placeholder="Number of publications" formControlName="publicationsPerYear" />
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Alumni">
            <div class="alumni-management-section">
                <p class="text-sm text-500 mb-4">Manage institute alumni by category. Added entries will be displayed in
                    the table below.</p>

                <div *ngFor="let cat of alumniCategories" class="alumni-category-container mb-5">
                    <div class="flex justify-content-between align-items-center mb-3">
                        <div class="flex align-items-center gap-3">
                            <p-checkbox [formControlName]="getCheckboxControlName(cat.type)" [binary]="true"
                                [inputId]="cat.type"></p-checkbox>
                            <label [for]="cat.type" class="text-xl font-bold text-900 cursor-pointer">{{ cat.label
                                }}</label>
                        </div>
                        <button pButton label="Add Entry" icon="pi pi-plus"
                            class="p-button-primary p-button-sm add-alumni-btn"
                            [disabled]="!form.get(getCheckboxControlName(cat.type))?.value"
                            (click)="openAddAlumniDialog(cat.type)"></button>
                    </div>

                    <div *ngIf="form.get(getCheckboxControlName(cat.type))?.value" class="alumni-chips-wrapper mt-3">
                        <ng-container
                            *ngIf="(form.get(getListNameByCategory(cat.type))?.value || []).length > 0; else noAlumni">
                            <div class="alumni-chips-list">
                                <div *ngFor="let entry of (form.get(getListNameByCategory(cat.type))?.value || []); let i = index"
                                    class="alumni-chip-card">
                                    <div class="alumni-chip-avatar">
                                        <img *ngIf="entry.imagePreview" [src]="entry.imagePreview" alt="Alumni" />
                                        <i *ngIf="!entry.imagePreview" class="pi pi-user"></i>
                                    </div>
                                    <span class="alumni-chip-name">{{ entry.firstName }} {{ entry.lastName }}</span>
                                    <span *ngIf="entry.designation" class="alumni-chip-designation block text-sm text-500 mt-1">{{ entry.designation }}</span>
                                    <button *ngIf="isEditMode" class="alumni-chip-action edit"
                                        (click)="editAlumniEntry(cat.type, i)" pTooltip="Edit" tooltipPosition="top"
                                        type="button">
                                        <i class="pi pi-pencil"></i>
                                    </button>
                                    <button class="alumni-chip-action remove" (click)="removeAlumniEntry(cat.type, i)"
                                        pTooltip="Remove" tooltipPosition="top" type="button">
                                        <i class="pi pi-times"></i>
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #noAlumni>
                            <p class="text-500 text-sm mt-2 ml-1">No entries yet. Click 'Add Entry' to begin.</p>
                        </ng-template>
                    </div>
                </div>
            </div>
        </p-accordionTab>


        <p-accordionTab header="Location Coordinates">
            <div class="formgrid grid">
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900" for="latitude">Latitude</label>
                    <input pInputText id="latitude" type="text" class="w-full" placeholder="e.g. 40.7128"
                        formControlName="latitude" />
                    <div *ngIf="form.get('latitude')?.touched && form.get('latitude')?.invalid">
                        <small *ngIf="form.get('latitude')?.hasError('required')" class="p-error block">Latitude is
                            required.</small>
                        <small *ngIf="form.get('latitude')?.hasError('pattern')" class="p-error block">Invalid latitude
                            format.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900" for="longitude">Longitude</label>
                    <input pInputText id="longitude" type="text" class="w-full" placeholder="e.g. -74.0060"
                        formControlName="longitude" />
                    <div *ngIf="form.get('longitude')?.touched && form.get('longitude')?.invalid">
                        <small *ngIf="form.get('longitude')?.hasError('required')" class="p-error block">Longitude is
                            required.</small>
                        <small *ngIf="form.get('longitude')?.hasError('pattern')" class="p-error block">Invalid
                            longitude format.</small>
                    </div>
                </div>
                <div class="col-12 mt-2">
                    <div class="surface-ground border-1 border-300 border-round-xl overflow-hidden"
                        style="height: 300px; width: 100%;">
                        <google-map [center]="center" [zoom]="zoom" height="300px" width="100%">
                            <map-marker [position]="center"></map-marker>
                        </google-map>
                    </div>
                </div>
            </div>
        </p-accordionTab>

    </p-accordion>



    <p-dialog header="Crop Image" [(visible)]="displayCropper" [modal]="true" [style]="{width: '600px'}"
        [draggable]="false" [resizable]="false" (onShow)="initCropper()" (onHide)="onDialogHide()" appendTo="body">
        <div class="cropper-container" style="max-height: 400px; overflow: hidden;">
            <img #cropperImage [src]="imageToCrop" style="max-width: 100%; display: block;" *ngIf="imageToCrop" />
        </div>
        <ng-template pTemplate="footer">
            <button pButton label="Cancel" class="cropper-cancel-btn"
                [loading]="loadder && cropperActionType === 'cancel'" (click)="closeCropper()"></button>
            <button pButton label="Crop" class="cropper-save-btn" [loading]="loadder && cropperActionType === 'save'"
                (click)="saveCrop()"></button>
        </ng-template>
    </p-dialog>


    <p-dialog header="Add New Province / State" [(visible)]="showAddProvinceDialog" [modal]="true"
        [style]="{width: '440px'}" [draggable]="false" [resizable]="false" styleClass="add-province-dialog"
        appendTo="body">
        <div class="add-province-form">
            <div class="province-field">
                <label>Province / State Name</label>
                <input pInputText type="text" [(ngModel)]="newProvince.name" [ngModelOptions]="{standalone: true}"
                    placeholder="e.g. Punjab, Ontario, California" class="w-full province-input" />
                <small *ngIf="provinceSubmitted && !newProvince.name" class="p-error">Province name is required.</small>
            </div>
            <div class="province-field">
                <label>Province Code</label>
                <input pInputText type="text" [(ngModel)]="newProvince.code" [ngModelOptions]="{standalone: true}"
                    placeholder="e.g. PB, ON, CA" class="w-full province-input" style="text-transform: uppercase;" />
                <small *ngIf="provinceSubmitted && !newProvince.code" class="p-error">Province code is required.</small>
            </div>
            <input type="hidden" [value]="newProvince.countryId" />
            <div class="province-country-hint" *ngIf="selectedCountryName">
                <i class="pi pi-globe"></i>
                <span>Adding to: <strong>{{ selectedCountryName }}</strong></span>
            </div>
        </div>
        <ng-template pTemplate="footer">
            <button pButton label="Cancel" class="province-cancel-btn" (click)="closeAddProvinceDialog()"></button>
            <button pButton label="Add Province" icon="pi pi-check" class="province-save-btn" [loading]="savingProvince"
                (click)="saveNewProvince()"></button>
        </ng-template>
    </p-dialog>

    <p-dialog header="Add New City" [(visible)]="showAddCityDialog" [modal]="true" [style]="{width: '420px'}"
        [draggable]="false" [resizable]="false" styleClass="add-province-dialog" appendTo="body">
        <div class="add-province-form">
            <div class="province-field">
                <label>City Name</label>
                <input pInputText type="text" [(ngModel)]="newCity.name" [ngModelOptions]="{standalone: true}"
                    placeholder="e.g. Lahore, Toronto, Los Angeles" class="w-full province-input" />
                <small *ngIf="citySubmitted && !newCity.name" class="p-error">City name is required.</small>
            </div>
            <input type="hidden" [value]="newCity.provinceId" />
            <div class="province-country-hint" *ngIf="selectedProvinceName">
                <i class="pi pi-map-marker"></i>
                <span>Adding to: <strong>{{ selectedProvinceName }}</strong></span>
            </div>
        </div>
        <ng-template pTemplate="footer">
            <button pButton label="Cancel" class="province-cancel-btn" (click)="closeAddCityDialog()"></button>
            <button pButton label="Add City" icon="pi pi-check" class="province-save-btn" [loading]="savingCity"
                (click)="saveNewCity()"></button>
        </ng-template>
    </p-dialog>

    <p-dialog [header]="isEditingAlumni ? 'Edit Alumni Entry' : 'Add Alumni Entry'" [(visible)]="showAlumniDialog"
        [modal]="true" [style]="{width: '500px'}" [draggable]="false" [resizable]="false"
        styleClass="alumni-entry-dialog shadow-4" appendTo="body">
        <div class="flex flex-column gap-4 py-3">
            <div class="flex flex-column align-items-center gap-2">
                <div class="alumni-upload-box" [class.has-image]="currentAlumniEntry.imagePreview"
                    (click)="alumniImgInput.click()">
                    <ng-container *ngIf="!currentAlumniEntry.imagePreview">
                        <div class="upload-content">
                            <i class="pi pi-upload text-2xl mb-2"></i>
                            <span class="text-xs font-medium">Click to upload photo</span>
                            <span class="text-xs text-400 mt-1">Square JPG/PNG</span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="currentAlumniEntry.imagePreview">
                        <img [src]="currentAlumniEntry.imagePreview" class="preview-img" alt="Alumni Preview" />
                        <div class="change-overlay">
                            <i class="pi pi-pencil mr-1"></i>
                            <span>Change</span>
                        </div>
                    </ng-container>
                </div>
                <input #alumniImgInput type="file" hidden accept="image/*" (change)="onAlumniFileSelect($event)" />
            </div>

            <div class="field flex flex-column gap-2 mb-0">
                <label class="font-bold text-900">First Name</label>
                <input pInputText [(ngModel)]="currentAlumniEntry.firstName" [ngModelOptions]="{standalone: true}"
                    placeholder="Enter first name" class="w-full" />
            </div>

            <div class="field flex flex-column gap-2 mb-0">
                <label class="font-bold text-900">Last Name</label>
                <input pInputText [(ngModel)]="currentAlumniEntry.lastName" [ngModelOptions]="{standalone: true}"
                    placeholder="Enter last name" class="w-full" />
            </div>

            <div class="field flex flex-column gap-2 mb-0">
                <label class="font-bold text-900">Designation</label>
                <input pInputText type="text" [(ngModel)]="currentAlumniEntry.designation"
                    [ngModelOptions]="{standalone: true}" placeholder="Enter Designation"
                    class="w-full" />
            </div>
        </div>

        <ng-template pTemplate="footer">
            <div class="flex justify-content-end gap-2 w-full mt-2">
                <button pButton label="Cancel" icon="pi pi-times" class="p-button-text p-button-secondary"
                    (click)="showAlumniDialog = false"></button>
                <button pButton [label]="isEditingAlumni ? 'Update' : 'Submit'" icon="pi pi-check"
                    class="p-button-primary" (click)="saveAlumniEntry()"></button>
            </div>
        </ng-template>
    </p-dialog>

</div>